import { useEffect, useState } from 'react';

const jwtQueryParameterName = 'ernToken';

const getQueryParams = () => (
  window.location.search.substr(1).split('&').reduce((queryObject, queryElement) => {
    const [key, value] = queryElement.split('=');

    queryObject[key] = decodeURIComponent(value); // eslint-disable-line no-param-reassign

    return queryObject;
  }, {})
);

export const isPayloadValid = (payload) => (
  payload.policy_display_number?.length > 0
  && payload.policy_id?.length > 0
  && payload.policy_chain_id?.length > 0
);

export const useJWTPayload = () => {
  const [jwt, setJWT] = useState(null);
  const [payload, setPayload] = useState({});

  useEffect(() => {
    const queryParams = getQueryParams();

    setJWT(queryParams[jwtQueryParameterName] || null);
  }, []);

  useEffect(() => {
    if (jwt) {
      const [, payloadBlock] = jwt.split('.');

      try {
        const payloadJsonString = atob(payloadBlock);
        const payloadObject = JSON.parse(payloadJsonString);

        setPayload(payloadObject);
      } catch (e) {
        setPayload({});
      }
    }
  }, [jwt]);

  return [jwt, payload];
};

const ernNumber = ({ taxOfficeCode, taxOfficeEmployerReference }) => (`${taxOfficeCode}/${taxOfficeEmployerReference}`);

export const useErnResponseSubmit = (jwt, setError) => {
  const onSubmit = async ({ customerHaveErn, exemptionReason, ...data }) => {
    const submitPayload = customerHaveErn ? { ern: ernNumber(data) } : { exemption_reason: exemptionReason };

    try {
      const response = await fetch(`${process.env.REACT_APP_PROSPECT_SERVICE_ENDPOINT || ''}/ern/response`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${jwt}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: submitPayload }),
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-cache',
      });

      if (response.status !== 200) {
        setError('submit', { message: `unexpected status code ${response.status}` });
      }
    } catch (e) {
      setError('submit', { message: e.message });
    }
  };

  return { onSubmit };
};
